export default "__VITE_ASSET__2f61bb3e__"